module.exports = require("./ca-ES-valencia.js");